export default __webpack_public_path__ + "static/media/math-background-8.02d8c601.png";